export enum AdminClientProfileApiTags {
  ClientProfile = 'ClientProfile',
}

export const adminClientProfileApiTagTypes = Array.from(Object.values(AdminClientProfileApiTags));
